<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row" v-if="($store.state.role == 'admin' || $store.state.role == 'branches' || $store.state.role == 'izbank-admin')">
                <div class="col-12 mb-2" v-if="Object.keys(legalCustomerDetails).length">
                    <h5>اطلاعات سازمان</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover user-details-table">
                            <tbody>
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12">
                    <nav class="nav nav-tabs mb-3">
                        <a class="nav-link ml-1 active" @click="setChargeType('single')" data-toggle="tab" href="#single">شارژ تکی</a>
                        <a class="nav-link" @click="setChargeType('multi')" data-toggle="tab" href="#multi">شارژ گروهی</a>
                    </nav>
                    <div class="tab-content">
                        <form class="tab-pane active show" id="single" v-on:submit.prevent="submit">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>شماره کارت</label>
                                        <input type="tel" class="form-control text-center" v-mask="'####-####-####-####'" v-model="pan" dir="ltr" style="direction: ltr !important">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>کد ملی</label>
                                        <input type="tel" class="form-control ltr-input" maxlength="10" v-model="nationalCode">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>مبلغ شارژ (ریال)</label>
                                        <input type="tel" class="form-control ltr-input" @keyup="e => changeDeposit(e)" v-model="deposit">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>شناسه ارجاع</label>
                                        <input type="tel" v-model="rrn" class="form-control ltr-input">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>شماره سند</label>
                                        <input type="tel" v-model="paymentId" class="form-control ltr-input">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-success">ثبت درخواست</button>
                                </div>
                            </div>
                        </form>
                        <div class="tab-pane" id="multi">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>انتخاب فایل شارژ</label>
                                    <div class="input-group file-browser">
                                        <input type="text" class="form-control border-left-0 browse-file" id="contract-file" placeholder="آپلود فایل" readonly="">
                                        <label class="input-group-btn mb-0">
                                            <span class="btn btn-primary">
                                                انتخاب کنید <input type="file" style="display: none;" accept=".xlsx" @input="setExcelFile">
                                            </span>
                                        </label>
                                    </div>
                                    <p class="mt-3 mb-0">
                                        <a href="#" @click="e => getExcelSample(e)">دریافت فایل نمونه</a>
                                    </p>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>شناسه ارجاع</label>
                                        <input type="tel" class="form-control ltr-input" v-model="rrnIdentifier" maxlength="30">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>شماره سند</label>
                                        <input type="tel" class="form-control ltr-input" v-model="paymentIdentifier" maxlength="30">
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="false">
                                    <div class="form-group">
                                        <label>میزان تخفیف</label>
                                        <input type="tel" class="form-control ltr-input" @keyup="e => changeCustomDepositValue(e)" v-model="discount">
                                    </div>
                                </div>
                                <div class="col-md-12 mt-2">
                                    <button class="btn btn-success" v-if="file" :disabled="!rrnIdentifier || !paymentIdentifier" @click="submit">ثبت درخواست</button>
                                    <button class="btn btn-primary mr-2" v-if="resultFile" @click="getResultExcelFile">دریافت فایل نتیجه</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="domain">سازمان</label>
                        <Vselect @input="searchCustomer" v-model="nationalCode" :reduce="item => item.nationalId" label="title" :options="organizations">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <form v-on:submit.prevent="searchCustomer">
                        <label for="national-code">شناسه ملی</label>
                        <div class="input-group">
                            <input class="form-control text-left" maxlength="11" id="national-code" type="tel" v-model="nationalCode">
                            <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Charge',
    data(){
        return {
            resultFile: '',
            showLoading: false,
            legalCustomerDetails: {},
            nationalCode: '',
            file: '',
            deposit: '',
            discount: 0,
            pan: '505785',
            organizations: [],
            chargeType: '',
            paymentIdentifier: '',
            rrnIdentifier: '',
            rrn: '',
            paymentId: '',
            amount: 0,
            customerId: 0
        }
    },
    methods: {
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status)
                    this.legalCustomerDetails = data.result;
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getExcelSample(e){
            e.preventDefault();
            this.$api.get('Branches/Charge/Sample').then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            this.resultFile = '';
            document.getElementById('contract-file').setAttribute('placeholder',file.name);
        },
        changeDeposit(e){
            let value = this.deposit ? this.deposit.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value))
                e.preventDefault();
            if(value > 100000000)
                value = 100000000;
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.deposit = value;
        },
        changeCustomDepositValue(e){
            let value = this.discount ? this.discount.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value)){
                e.preventDefault();
            }
            if(value > 100000000)
                value = 100000000;
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.discount = value;
        },
        getResultExcelFile(){
            let csvString = this.resultFile;
            let universalBOM = '\uFEFF';
            let a = window.document.createElement('a');
            a.setAttribute('href','data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
            let fileName = 'charge.csv';
            a.setAttribute('download',fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        setChargeType(chargeType){
            this.chargeType = chargeType;
        },
        submit(){
            this.showLoading = true;
            let postedData = {};
            if(this.chargeType == 'multi'){
                postedData = {
                    file: this.file,
                    paymentId: this.paymentIdentifier,
                    rrn: this.rrnIdentifier,
                    description: '',
                    items: null
                };
            }else{
                postedData = {
                    rrn: this.rrn,
                    paymentId: this.paymentId,
                    description: '',
                    items: {
                        pan: this.pan.replace(/-/g,''),
                        nationalCode: this.nationalCode,
                        amount: parseInt(this.deposit.replace(/,/g,'')),
                        description: ''
                    }
                };
            }
            this.$api.post('Branches/Charge',postedData).then(({data}) => {
                if(data.result.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'ثبت درخواست شارژ با موفقیت انجام شد',
                    }).then(res => {
                        if(res.isConfirmed){
                            this.$router.push({name: 'bankBranches.requests'});
                        }
                    });
                else{
                    this.resultFile = data.result.file;
                    this.$swal({
                        icon: 'error',
                        title: 'خطا !',
                        text: data.result.description,
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    }
}
</script>